/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1750
 */

require(/* 578 */"./578/index")("Uint32", function (e) {
  return function (t, n, r) {
    return e(this, t, n, r)
  }
})
